export const LOADING_FORM_SURVEY = 'LOADING_FORM_SURVEY';
export const ERROR_FORM_SURVEY = 'ERROR_FORM_SURVEY';
export const RESET_FORM_SURVEY = 'RESET_FORM_SURVEY';
